<template>
<div>
  <v-icon v-if="item.printLabel" color="grey darken-2" class="mr-2" @click='printLabel(item)'>
    mdi-printer-pos
  </v-icon>
  <v-icon v-if="item.printInvoice" color="green darken-2" class="mr-2" @click='printInvoicePdf(item)'>
    mdi-printer-outline
  </v-icon>
  <v-icon v-if="item.printInvoice" color="green darken-2" class="mr-2" @click='printProformaInvoicePdf(item)'>
    mdi-printer
  </v-icon>
  <PackageLabel v-if="item.printTipax" :person_mid="item._id" />
  <!-- <v-icon v-if="item.printTipax" color="green darken-2" class="mr-2" @click='printTipaxPdf(item)'>
    mdi-printer-outline
  </v-icon> -->
  <v-icon v-if="item.printTipax" color="green darken-2" class="mr-2" @click='printChapar(item)'>
    mdi-printer
  </v-icon>
  <v-icon v-if="telegram" color="blue darken-2" class="mr-2" @click='sendTg(item)'>
    mdi-send
  </v-icon>
  <v-icon color="orange darken-2" class="mr-2" @click="edit(item)">
    mdi-pencil
  </v-icon>
  <v-icon color="red darken-2" class="mr-2" @click='remove(item)'>
    mdi-delete
  </v-icon>
</div>
</template>
<script>
import Vue from 'vue'
import {
  showSnackbar
} from "../../components/MySnackbar/globalActions"
import myDate from '../../functions/myDate'
import vueAxios from '../../functions/vueAxios'
import myAxios from '../../functions/myAxios'
import PrintInvoice from './PrintInvoice.vue'
import PrintTipax from './PrintTipax.vue'
import PrintChapar from './Chapar.vue'
import retrieveInvoiceData from '../../functions/retrieveInvoiceData'
import retrievePackageLabelData from '../../functions/retrievePackageLabelData'
import PackageLabel from '../PackageLabel.vue'
const objPersonInfo = {
  name: "امیر قاسمی",
  address: "۱۷ش",
  mobile: "09151194250",
  gender: true
}
export default {
  name: 'MyListActionKeys',
  props: ['item'],
  components: {
    PackageLabel
  },
  created() {
    this.route = this.$store.getters.pageInfo.route
    this.formTitle = this.$store.getters.pageInfo.formTitle
    const tg = ['/', 'persons', 'invoices', 'lendings', 'receipts', 'payments', 'transfers']
    this.telegram = tg.includes(this.route)
  },
  methods: {
    async sendTg(item) {
      let _type = 'doc'
      if (this.route === 'persons') _type = 'persons'
      if (window.confirm(`آیا مایل به ارسال جزئیات سند انتخابی در تلگرام هستید؟`) === true) {
        // setLoading(true);
        try {
          let res = await myAxios({
            method: 'put',
            url: `/api/${_type}/whatsapp`,
            data: {
              mid: item._id
            }
          });
          if (res && res.data && res.data.insert) {
            showSnackbar("اطلاعات با موفقیت به تلگرام ارسال شد", 'success');
          }
        } catch (err) {
          console.log(`${this.route}.sendTg => ${err}`);
        }
      }
    },
    async edit(item) {
      // console.log(item);
      let route = this.route;
      if (route === "/") {
        route = this.getRoute(item.type)
      }
      this.$router.push({
        path: `/${route}/edit/${item._id}`
      }) // -> /banks/edit/123
    },
    async remove(item) {
      let _params = {
        mid: item._id
      }
      let _title = item.title;
      let route = this.route;
      if (route === "/") {
        route = this.getRoute(item.type)
      }
      if (route === 'bank_accounts') {
        _title = item.number
      } else if (['invoices', 'receipts', 'payments', 'lendings', 'transfers'].includes(route)) {
        _title = item.id
      } else if (route === 'persons') {
        _title = `(${item.name})`
      } else {
        _title = item.title
      }
      _params.title = _title
      if (window.confirm(`آیا مایل به حذف سند ${_title} انتخابی هستید؟`) === true) {
        // setLoading(true);
        try {
          let res = await myAxios({
            method: 'DELETE',
            url: `/api/${route}`,
            params: _params
          });
          if (res && res.data) {
            // console.log(res.data);
            let message = ``
            let title = `سند`
            if (res.data.used) {
              message = `${title}  مورد نظر به علت استفاده در سیستم قابل حذف نیست.`
              showSnackbar(message, 'warning')
            } else if (['persons', 'products', 'boxes', 'bank_accounts'].includes(route) && res.data._delete && res.data._delete_init > 0 || ['banks', 'costs', 'incomes', 'invoices', 'receipts', 'payments', 'lendings', 'transfers', 'roles']
              .includes(route) && res.data.acknowledged &&
              res.data
              .deletedCount > 0) {
              message = `${title} مورد نظر با موفقیت حذف شد.`
              showSnackbar(message, 'success')
              setTimeout(() => {
                this.$router.go()
              }, 500)
            } else {
              message = `در عملیات حذف ${title}، خطایی رخ داده...`
              showSnackbar(message, 'warning')
            }
          }
        } catch (err) {
          console.log(`${route}.remove => ${err}`);
        }
      }
    },
    async printInvoice(item) {
      await this.retrieveInvoice(item)
      if (this.invoiceData.length) return
      //
      const printWindow = window.open('', '_blank');
      if (printWindow) {
        // Render the invoice component into a temporary div
        const tempDiv = document.createElement('invoice_printt');
        // Get all stylesheets HTML
        let stylesHtml = '';
        for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
          stylesHtml += node.outerHTML;
        }
        const app = new Vue({
          render: h => h(PrintInvoice, {
            props: {
              data: this.invoiceData
            }
          })
        }).$mount(tempDiv);

        printWindow.document.write(`
              <html>
                <head>
                  <title>Invoice</title>
                  ${stylesHtml}
                </head>
                <body>
                  ${app.$el.innerHTML}
                </body>
              </html>
            `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
          printWindow.print();
          printWindow.close();
        }, 500)
        // Optional: Close the print window after printing
        // printWindow.close();
      } else {
        alert('Please allow pop-ups to print the invoice.');
      }
    },
    async printInvoicePdf(item) {
      const invoiceData = await retrieveInvoiceData(item._id)
      invoiceData.invoiceTitle = 'فاکتور فروش'
      invoiceData.invoiceComment = `کلیه اقلام فاکتور تحویل خریدار شد.`
      // console.log(invoiceData);
      try {
        const res = await vueAxios.get('/invoices/pdf', {
          params: invoiceData,
          responseType: 'blob',
        })
        // console.log(res.data);
        const file = new Blob([res.data], {
          type: 'application/pdf'
        });
        const fileURL = URL.createObjectURL(file);
        // console.log(fileURL);
        window.open(fileURL, '_blank');
      } catch (err) {
        console.error("❌ Error fetching QR PDF:", err);
      }
    },
    async printProformaInvoicePdf(item) {
      const invoiceData = await retrieveInvoiceData(item._id)
      invoiceData.invoiceTitle = 'پیش  فاکتور فروش'
      invoiceData.invoiceComment = `اعتبار پیش فاکتور ۴۲ ساعت.`
      // console.log(invoiceData);
      try {
        const res = await vueAxios.get('/invoices/pdf', {
          params: invoiceData,
          responseType: 'blob',
        })
        // console.log(res.data);
        const file = new Blob([res.data], {
          type: 'application/pdf'
        });
        const fileURL = URL.createObjectURL(file);
        // console.log(fileURL);
        window.open(fileURL, '_blank');
      } catch (err) {
        console.error("❌ Error fetching QR PDF:", err);
      }
    },
    async retrieveInvoice(item) {
      if (!item) return
      //
      try {
        // this.loading = true
        let res = await myAxios({
          method: 'GET',
          url: `/api/invoices/print`,
          params: {
            mid: item._id
          }
        })
        if (res?.data) {
          res.data.invoice.invoice_date = new Date(res.data.invoice.create_date).getTime() // for label
          res.data.invoice.create_date = myDate.toJalaali(res.data.invoice.create_date).date
          res.data.invoice.items.forEach((item) => {
            if (item.second_value) {
              item.price = (item.price * item.product_id.n).toFixed(0)
              // console.log(item);
            }
          })
          // console.log(this.invoiceData);
          this.invoiceData = res.data
        } else {
          this.invoiceData = []
        }
      } catch (e) {
        console.error(e)
      } finally {
        // this.loading = false
      }
    },
    async printTipax(item) {
      await this.retrieveTipaxData(item)
      if (this.tipaxData.length) return
      //
      const printWindow = window.open('', '_blank');
      if (printWindow) {
        // Render the invoice component into a temporary div
        const tempDiv = document.createElement('tipax_print');
        // Get all stylesheets HTML
        let stylesHtml = '';
        for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
          stylesHtml += node.outerHTML;
        }
        const app = new Vue({
          render: h => h(PrintTipax, {
            props: {
              data: this.tipaxData
            }
          })
        }).$mount(tempDiv);

        printWindow.document.write(`
              <html>
                <head>
                  <title>Invoice</title>
                  ${stylesHtml}
                </head>
                <body>
                  ${app.$el.innerHTML}
                </body>
              </html>
            `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
          printWindow.print();
          printWindow.close();
        }, 500)
        // Optional: Close the print window after printing
        // printWindow.close();
      } else {
        alert('Please allow pop-ups to print the invoice.');
      }
    },
    async printChapar(item) {
      await this.retrieveTipaxData(item)

      if (this.tipaxData.length) return

      const printWindow = window.open('', '_blank')

      if (!printWindow) {
        alert('Please allow pop-ups to print the invoice.')
        return
      }

      // انتقال استایل‌های موجود صفحه به پنجره چاپ
      const stylesHtml = [
          ...document.querySelectorAll(
            'link[rel="stylesheet"], style'
          )
        ]
        .map(node => node.outerHTML)
        .join('\n')

      // ساخت کامپوننت چاپ
      const tempDiv = document.createElement('div')

      const app = new Vue({
        render: h =>
          h(PrintChapar, {
            props: {
              data: this.tipaxData
            }
          })
      }).$mount(tempDiv)

      // آماده‌سازی سند مستقل چاپ
      printWindow.document.open()

      printWindow.document.write(`
    <!DOCTYPE html>
    <html lang="fa" dir="rtl">
      <head>
        <meta charset="UTF-8">

        <title>برچسب ارسال</title>

        <base href="${document.baseURI}">

        ${stylesHtml}

        <style>
          @page {
            size: A5 portrait;
            margin: 0;
          }

          html,
          body {
            width: 148mm !important;
            height: 210mm !important;

            margin: 0 !important;
            padding: 0 !important;

            overflow: hidden !important;
          }

          body {
            position: relative;
            font-family: Tahoma, sans-serif;
          }

          *,
          *::before,
          *::after {
            box-sizing: border-box;
          }

          .print-sheet {
            position: relative !important;

            display: block !important;

            width: 148mm !important;
            height: 210mm !important;

            margin: 0 !important;
            padding: 0 !important;

            overflow: hidden !important;

            break-before: avoid-page !important;
            break-after: avoid-page !important;

            page-break-before: avoid !important;
            page-break-after: avoid !important;
          }

          .shipping-label-page {
            position: absolute !important;

            top: 0 !important;
            right: 0 !important;
            left: auto !important;

            width: 148mm !important;
            height: 105mm !important;

            margin: 0 !important;

            overflow: hidden !important;
          }

          .shipping-label {
            height: 97mm !important;
            width : 138mm !important
          }

          @media print {
            html,
            body {
              width: 148mm !important;
              height: 210mm !important;

              margin: 0 !important;
              padding: 0 !important;

              overflow: hidden !important;
            }

            .print-sheet {
              width: 148mm !important;
              height: 210mm !important;
              overflow: hidden !important;
            }
          }
        </style>
      </head>

      <body>
        ${app.$el.outerHTML}
      </body>
    </html>
  `)

      // چاپ پس از آماده‌شدن سند و فونت‌ها
      printWindow.onload = async () => {
        try {
          if (printWindow.document.fonts) {
            await printWindow.document.fonts.ready
          }

          // کمی فرصت برای بارگذاری CSS و اعمال چیدمان
          await new Promise(resolve => setTimeout(resolve, 300))

          printWindow.focus()
          printWindow.print()
        } finally {
          printWindow.close()
        }
      }

      printWindow.document.close()
    },
    async retrieveTipaxData(item) {
      if (!item && !item._id) return
      //
      try {
        let res = await myAxios({
          method: 'GET',
          url: `/api/persons/print`,
          params: {
            mid: item._id
          }
        })
        if (res && res.data) {
          // console.log(res.data);
          this.tipaxData = res.data
        } else {
          this.tipaxData = []
        }
      } catch (e) {
        console.error(e)
      } finally {
        // this.loading = false
      }
    },
    async printLabel(item) {
      const type = {
        'فروش': 'invoices',
        'پرداخت کالا': 'lendings'
      }
      const printLabelUrl = `/${type[item.type]}/printLabel/${item._id}`
      this.$router.push(printLabelUrl)
    },
    async printTipaxPdf(item) {
      // console.log(item._id);
      try {
        const data = await retrievePackageLabelData(item._id)
        if (!data) return
        // console.log(data);

        const res = await vueAxios.get('/persons/pdf', {
          params: data,
          responseType: 'blob',
        })

        const file = new Blob([res.data], {
          type: 'application/pdf'
        })
        const fileURL = URL.createObjectURL(file)
        window.open(fileURL, '_blank')

        setTimeout(() => {
          URL.revokeObjectURL(fileURL)
        }, 2000)
      } catch (err) {
        console.error("❌ Error fetching tipax PDF:", err)
      }
    },
    async printInvoiceLabel(item) {
      // console.log(window.location.hostname);
      // console.log(window.location.port);
      let newTabUrl = `http://${window.location.hostname}:8888/feGcaByweLoCOJnR?`
      let AMOUNT
      if (this.route === 'invoices' || item.type === 'فروش') {
        AMOUNT = item.first_item.second_value ? Math.abs(item.first_item.value) / item.first_item.n : Math.abs(item.first_item.value)
      } else if (this.route === 'lendings' || item.type === 'پرداخت کالا') {
        AMOUNT = item.first_item.second_value ? Math.abs(item.first_item.lending_value) / item.first_item.n : Math.abs(item.first_item.lending_value)
      }
      const UNIT = item.first_item.second_value ? 'M' : 'G'
      const PRICE = item.first_item.price
      newTabUrl += `amount=${(parseFloat(AMOUNT.toFixed(3)))}&`
      newTabUrl += `unit=${UNIT}&`
      if (PRICE) newTabUrl += `price=${PRICE}&`
      newTabUrl += `invoice_id=${item.id}&`
      newTabUrl += `invoice_date=${new Date(item.date).getTime()}`
      window.open(newTabUrl, '_blank');
    },
    getRoute(type) {
      if (["خرید", "فروش"].includes(type)) {
        return "invoices"
      } else if (type === "دریافت") {
        return "receipts"
      } else if (type === "پرداخت") {
        return "payments"
      } else if (["حواله"].includes(type)) {
        return "transfers"
      } else if (["دریافت کالا", "پرداخت کالا"].includes(type)) {
        return "lendings"
      }
    },
  },
  data() {
    return {
      telegram: false,
      invoiceData: [],
      tipaxData: [],
      showPrintTipax: false,
      personInfo: objPersonInfo
    }
  },
}
</script>
